import { Space } from 'antd';

export const PromtMutatorHelps = () => {
  return (
    <Space direction="vertical">
      Prompt mutators for the story, separated by ---
      <i>Translate to English. Format as a ballad but keep the narrative accuracy</i>
      <i>You can use variables:</i>
      <ul>
        <li>
          <code>{`<format>`}</code> - Request to format the answer
        </li>
        <li>
          <code>{`<promt>`}</code> - Prompt
        </li>
      </ul>
    </Space>
  );
};
